
import React from 'react';
import AboutPage from '../base/components/AboutPage';

const MyGLAboutPage = () => {
	return (<>
		<div className="MyPage widepage">
			<AboutPage />
		</div>
	</>);
};

export default MyGLAboutPage;
